const pad = (n: number, width = 2): string => String(n).padStart(width, "0");

export interface Formatted {
  text: string;
  /** Glyph count — the stylesheet uses it to fit the string to the viewport. */
  chars: number;
}

/**
 * `withHours` is decided from the configured duration, not the remaining time,
 * so the layout does not jump when the clock crosses an hour boundary.
 *
 * Whole seconds are rounded *up*: a 5:00 timer reads 05:00 for its whole first
 * second and 00:01 for its last, reaching 00:00 exactly at zero. With
 * milliseconds on, the fraction is visible, so it rounds down instead.
 */
export function formatRemaining(
  ms: number,
  withHours: boolean,
  withMillis: boolean,
): Formatted {
  const total = Math.max(0, ms);
  const seconds = withMillis
    ? Math.floor(total / 1000)
    : Math.ceil(total / 1000);

  let text: string;
  if (withHours) {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    text = `${pad(h)}:${pad(m)}:${pad(seconds % 60)}`;
  } else {
    text = `${pad(Math.floor(seconds / 60))}:${pad(seconds % 60)}`;
  }

  if (withMillis) text += `.${pad(Math.floor(total % 1000), 3)}`;

  return { text, chars: text.length };
}

/** Compact form for the browser tab, always to the second. */
export function formatTitle(ms: number, withHours: boolean): string {
  return formatRemaining(ms, withHours, false).text;
}
